import Vue from "vue";
import { db } from "../assets/js/firebase";
import Vuex from "vuex";
import moment from "moment";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    _form: {},
    _table: [],
    _listings: [],
  },
  mutations: {
    setForm(state, val) {
      state._form = val;
    },
    setTable(state, val) {
      state._table = val;
    },
    setListings(state, val) {
      state._listings = val;
    },
  },
  getters: {
    form(state) {
      return state._form;
    },
    table(state) {
      return state._table;
    },
    listings(state) {
      return state._listings;
    },
  },
  actions: {
    removeListen() {
      db.child("property").off("value");
    },
    get(context) {
      return new Promise((resolve) => {
        db.child("property")
          .orderByChild("status")
          .equalTo("no")
          .once("value")
          .then((snap) => {
            let list = [];
            snap.forEach((doc) => {
              list.push(doc.val().name);
            });
            context.commit("setListings", list);
            resolve();
          });
      });
    },
    listen(context) {
      db.child("property")
        .orderByChild("name")
        .on("value", (snap) => {
          let list = [];
          console.log("welcome");
          snap.forEach((doc) => {
            let data = doc.val();
            data.key = doc.key;
            let { date } = data;
            var start = moment(date);
            var end = moment();
            let diff = end.diff(start, "days");
            if (diff < 0) diff = 0;
            data.days = diff;
            list.push(data);
          });
          context.commit("setTable", list);
        });
    },
  },
  modules: {},
});
